import React, { useCallback, useEffect, useMemo, useState } from 'react';
import classNames from 'classnames';
import dayjs from 'dayjs';

import SocialInfo from './SocialInfo';
import MintInfo from './MintInfo';
import { useAppSelector } from 'store/hooks';
import fireIcon from 'assets/icons/fireButtonIcon.json';
import { Raffle } from 'api/raffle/raffle_detail';
import Banner from './Banner';
import Lottie from 'lottie-react';

interface ICoreInfoProps {}

const CoreInfo: React.FC<ICoreInfoProps> = ({}) => {
  const { raffleInfo } = useAppSelector((state) => state.raffleDetails);
  const [raffle, setRaffle] = useState<Raffle>();

  useEffect(() => {
    setRaffle(raffleInfo);
  }, [raffleInfo]);

  const handleError = (e: any) => {
    e.target.src =
      'https://s.luckygo.io/luckybuy/img/detailAvatarImg.png';
  };

  const handleOpenProjectTwitter = useCallback(() => {
    if (!!raffle?.project?.twitter_screen_name) {
      open(`https://twitter.com/${raffle?.project?.twitter_screen_name}`);
    }
  }, [raffle?.project?.twitter_screen_name]);

  const handleOpenCampaignTwitter = useCallback(() => {
    if (!!raffle?.campaign?.twitter_link) {
      open(raffle?.campaign?.twitter_link);
    }
  }, [raffle?.campaign?.twitter_link]);

  const startTime = useMemo(() => {
    return dayjs(raffle?.start_time).format('MMMM D, YYYY HH:mm');
  }, [raffle?.start_time]);

  const endTime = useMemo(() => {
    return dayjs(raffle?.end_time).format('MMMM D, YYYY HH:mm');
  }, [raffle?.end_time]);

  return (
    <div className=" w-full">
      <Banner />
      <div className="md:flex md:items-end ">
        <div className="z-10 flex items-center justify-center md:justify-start relative">
          {!raffle?.is_hide_project_logo && (
            <div
              className={classNames(
                ' -mt-12 h-[96px] w-[96px] rounded-full border-[3px] border-[#FCFCFD] bg-[#232323] md:-mt-[60px] md:h-[120px] md:w-[120px]',
                {
                  ' md:ml-5 ':
                    raffle?.campaign?.logo && !raffle?.is_hide_community_logo,
                }
              )}
            >
              {!!raffle?.project?.logo ? (
                <img
                  className={classNames('h-full w-full rounded-full', {
                    'cursor-pointer': !!raffle?.project?.twitter_screen_name,
                  })}
                  src={raffle?.project?.logo}
                  alt=""
                  onError={handleError}
                  onClick={handleOpenProjectTwitter}
                />
              ) : (
                <img
                  src="https://s.luckygo.io/luckybuy/img/detailAvatarImg.png"
                  className={classNames('h-full w-full rounded-full', {
                    'cursor-pointer': !!raffle?.project?.twitter_screen_name,
                  })}
                  alt=""
                  onClick={handleOpenProjectTwitter}
                />
              )}
            </div>
          )}

          {!!raffle?.campaign?.logo && !raffle?.is_hide_community_logo && (
            <div
              className={classNames(
                ' -mt-12  h-[96px] w-[96px] rounded-full border-[3px] border-[#FCFCFD] bg-[#232323]  md:-mt-[60px] md:mr-0 md:h-[120px] md:w-[120px]',
                {
                  '-ml-4': !raffle?.is_hide_project_logo,
                }
              )}
            >
              <img
                className={classNames('h-full w-full rounded-full', {
                  'cursor-pointer': !!raffle?.campaign?.twitter_link,
                })}
                src={raffle?.campaign?.logo}
                alt=""
                onError={handleError}
                onClick={handleOpenCampaignTwitter}
              />
            </div>
          )}
        </div>
        <div
          className={classNames(' w-full ', {
            'pt-6':
              raffle?.is_hide_project_logo && raffle?.is_hide_community_logo,
          })}
        >
          <div className="flex flex-col items-center justify-center md:flex-row md:justify-between">
            <div
              className={classNames(
                'my-4 flex h-8 items-center justify-center truncate  rounded-full border border-primary-500 px-4 text-xs font-normal leading-4 text-primary-500 md:my-0',
                {
                  'cursor-pointer hover:text-primary-400 hover:border-primary-400': !!raffle?.campaign?.twitter_link,
                }
              )}
              onClick={handleOpenCampaignTwitter}
            >
              {raffle?.campaign?.name}
            </div>
            <SocialInfo></SocialInfo>
          </div>
        </div>
      </div>

      <div className="mb-1 mt-8 truncate whitespace-pre-wrap text-left text-[32px] font-semibold text-neutral-100 md:text-left">
        {raffle?.name}
      </div>
      <div className="mb-4 flex items-center gap-1 text-neutral-100">
        {!!raffle?.project?.is_recommend && (
          <Lottie animationData={fireIcon} style={{ width: 16 }} />
        )}
        <div>
          {startTime} ~ {endTime}
        </div>
      </div>
      <MintInfo></MintInfo>
    </div>
  );
};

export default CoreInfo;
